import { OverlayTrigger, Popover } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import "./spreadSheetImport.scss";
import { ReactComponent as ImportIcon } from "assets/images/icons/Import.svg";
import { ReactComponent as ExportIcon } from "assets/images/icons/TopNavIcons/ExportIcon.svg";
import DownloadTemplate from "./DownloadTemplate";

interface ISpreadSheetPopover {
  packingListConfig: any;
  setShowSpreadsheetImport: (showDialog: boolean) => void;
}

function SpreadSheetPopover({ packingListConfig, setShowSpreadsheetImport }: ISpreadSheetPopover) {
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={
        <Popover
          id="popover-trigger-click"
          className="export-popover position-absolute"
          style={{
            width: "191px",
            border: "none",
            padding: "16px",
            boxShadow: "0px 2px 8px rgba(0,0,0, 0.15)",
          }}
        >
          <Popover.Content style={{ padding: 0 }}>
            <div className="d-flex flex-column">
              <ul>
                <li
                  className="export-tab-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSpreadsheetImport(true);
                  }}
                >
                  <ImportIcon />
                  <span className="font-12 ml-2">
                    <FormattedMessage id="new-request.packing-list.importPackingList" defaultMessage="Import packing list" />
                  </span>
                </li>
                <li onClick={(e) => e.stopPropagation()}>
                  <DownloadTemplate packingListConfig={packingListConfig} />
                </li>
              </ul>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <ExportIcon style={{ cursor: "pointer" }} onClick={(e) => e.stopPropagation()} />
    </OverlayTrigger>
  );
}

export default SpreadSheetPopover;
